"use client";

import { RouteErrorBoundary } from "@/app/_components/ui/route-error-boundary";

export default function PortalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <RouteErrorBoundary
      boundary="(portal)/portal"
      error={error}
      reset={reset}
    />
  );
}
